import { FormattedMessage } from '@flipster/i18n';
import { Datetime } from '@flipster/react/design-utils/datetime';
import { DateFormatter } from '@flipster/utils/datetime';

interface EventPeriodProps {
  start?: string;
  end?: string;
}

export const EventPeriod = ({ start, end }: EventPeriodProps) => {
  return (
    <FormattedMessage
      id='Competition.r251215.Event_period_date_range'
      values={{
        dateTimeRange: (
          <>
            <Datetime value={start} format={DateFormatter.DateTimeSlash} isUTC withUTCText />
            {' - '}
            <Datetime value={end} format={DateFormatter.DateTimeSlash} isUTC withUTCText />
          </>
        ),
      }}
    />
  );
};
